import React, { useState } from "react";
import "assets/scss/pages/_DesignSystemComponents.scss";
import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import { useParams } from "react-router-dom";
import { getComponentsSideData } from "assets/data/sideTabData";
import { useGlobalContext } from "context/GlobalContext";
import PreviewAlertComponents from "components/DesignSystemPage/AlertComponent/PreviewAlertComponent";
import UsageAlterComponent from "components/DesignSystemPage/AlertComponent/UsageAlterComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";
import { alertTokenTabData } from "assets/data/tokenTabData";


const AlertComponents = () => {
  const { id } = useParams();
  const { designSystemMeta, designSystem } = useGlobalContext();
  
     const componentName = "alert";
      const componentKey = `Component/${componentName}`;
      const componentData = designSystem[componentKey];
      const tokenTableData = alertTokenTabData(componentData, componentName);

  const tabData = [
    "Informative",
    "Caution",
    "Success",
    "Danger",
  ];
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };


  const bannerData = {
    heading: "Alert",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };
  const tabs = ["Preview", "Usage", "Tokens"];

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <PreviewAlertComponents
            tabData={tabData}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            setSelectedTab={setSelectedTab}
          />
        );
      case 1:
        return (
          <div>
            <UsageAlterComponent/>
          </div>
        );
      case 2:
        return <TokenTableComponent tokenTableData={tokenTableData} />;
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title='Components'
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default AlertComponents;
